"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSequenceAxis = BaseSequenceAxis;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var $ = require("jquery");

function BaseSequenceAxis(props) {
  var sequence_data = props.sequence_data,
      label_padding = props.label_padding,
      site_size = props.site_size,
      width = props.width,
      labels = sequence_data.map(function (record) {
    return record.header;
  });
  return /*#__PURE__*/_react["default"].createElement("g", {
    style: {
      fontFamily: "Courier",
      fontSize: 14
    },
    transform: "translate(".concat(props.translateX, ", ").concat(props.translateY, ")")
  }, labels.map(function (label, i) {
    return /*#__PURE__*/_react["default"].createElement("text", {
      x: width - label_padding,
      y: (i + 1) * site_size,
      textAnchor: "end",
      dy: -site_size / 3,
      key: i,
      fill: props.fill ? props.fill[i] : "black",
      onClick: props.onClick(label, i),
      fontWeight: props.bold ? "bold" : "normal"
    }, label);
  }));
}

BaseSequenceAxis.defaultProps = {
  translateX: 0,
  translateY: 0,
  label_padding: 5,
  site_size: 20,
  onClick: function onClick(label, i) {
    return function () {
      return null;
    };
  }
};

var SequenceAxis = /*#__PURE__*/function (_Component) {
  _inherits(SequenceAxis, _Component);

  var _super = _createSuper(SequenceAxis);

  function SequenceAxis(props) {
    var _this;

    _classCallCheck(this, SequenceAxis);

    _this = _super.call(this, props);
    _this.div_id = props.id + "-labels-div";
    return _this;
  }

  _createClass(SequenceAxis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var div_id = this.div_id;
      document.getElementById(div_id).addEventListener("alignmentjs_wheel_event", function (e) {
        $("#".concat(div_id)).scrollTop(e.detail.y_pixel);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      $("#".concat(this.div_id)).scrollTop(this.props.y_pixel);
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(e) {
      e.preventDefault();
      this.props.scroll_broadcaster.handleWheel(e, this.props.sender);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.sequence_data) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: this.div_id,
          className: "alignmentjs-container"
        });
      }

      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          site_size = _this$props.site_size,
          number_of_sequences = this.props.sequence_data.length,
          styles = {
        overflowX: "scroll",
        overflowY: "hidden",
        width: width,
        height: height
      },
          alignment_height = site_size * number_of_sequences;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.div_id,
        className: "alignmentjs-container",
        style: styles,
        onWheel: function onWheel(e) {
          return _this2.handleWheel(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        id: "alignmentjs-labels",
        width: width,
        height: alignment_height
      }, /*#__PURE__*/_react["default"].createElement(BaseSequenceAxis, this.props)));
    }
  }]);

  return SequenceAxis;
}(_react.Component);

SequenceAxis.defaultProps = {
  label_padding: 10,
  site_size: 20,
  id: "alignmentjs",
  sender: "main",
  onClick: function onClick(label, i) {
    return function () {
      return null;
    };
  }
};
var _default = SequenceAxis;
exports["default"] = _default;